"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCustomValidator = exports.getCustomValidator = exports.setValidationData = exports.getValidationData = void 0;
const validityUtils_1 = require("./validityUtils");
const defaultState = {
    validationData: validityUtils_1.INITIAL_VALIDATION_DATA,
    customValidators: [() => { }],
};
const NAMESPACE = 'validation';
const getValidationData = ({ createSdkState, }) => {
    const [state] = createSdkState(defaultState, NAMESPACE);
    return state.validationData;
};
exports.getValidationData = getValidationData;
const setValidationData = ({ createSdkState }, validationData) => {
    const [, setState] = createSdkState(defaultState, NAMESPACE);
    setState({ validationData });
};
exports.setValidationData = setValidationData;
const getCustomValidator = ({ createSdkState, }) => {
    const [{ customValidators }] = createSdkState(defaultState, NAMESPACE);
    return (value, reject) => {
        let abortValidation = false;
        const innerReject = (rejectMessage) => {
            abortValidation = true;
            reject(rejectMessage);
        };
        for (let idx = 0; idx < customValidators.length && !abortValidation; idx++) {
            customValidators[idx](value, innerReject);
        }
    };
};
exports.getCustomValidator = getCustomValidator;
const setCustomValidator = ({ createSdkState }, customValidator, override = true) => {
    const [{ customValidators }, setState] = createSdkState(defaultState, NAMESPACE);
    if (override) {
        setState({ customValidators: [customValidator] });
    }
    else {
        setState({
            customValidators: [...customValidators, customValidator],
        });
    }
};
exports.setCustomValidator = setCustomValidator;
//# sourceMappingURL=validationPropsSdkState.js.map